// PaySlipPAYSLIPType.js
// GET ALL PAYSLIPS
export const GET_ALL_PAYSLIPS_REQUEST = "GET_ALL_PAYSLIPS_REQUEST";
export const GET_ALL_PAYSLIPS_SUCCESS = "GET_ALL_PAYSLIPS_SUCCESS";
export const GET_ALL_PAYSLIPS_FAIL = "GET_ALL_PAYSLIPS_FAIL";

// GET ONE PAYSLIP
export const GET_ONE_PAYSLIP_REQUEST = "GET_ONE_PAYSLIP_REQUEST";
export const GET_ONE_PAYSLIP_SUCCESS = "GET_ONE_PAYSLIP_SUCCESS";
export const GET_ONE_PAYSLIP_FAIL = "GET_ONE_PAYSLIP_FAIL";

// DELETE PAYSLIP
export const DELETE_PAYSLIP_REQUEST = "DELETE_PAYSLIP_REQUEST";
export const DELETE_PAYSLIP_SUCCESS = "DELETE_PAYSLIP_SUCCESS";
export const DELETE_PAYSLIP_FAIL = "DELETE_PAYSLIP_FAIL";

// CREATE PAYSLIP
export const CREATE_PAYSLIP_REQUEST = "CREATE_PAYSLIP_REQUEST";
export const CREATE_PAYSLIP_SUCCESS = "CREATE_PAYSLIP_SUCCESS";
export const CREATE_PAYSLIP_FAIL = "CREATE_PAYSLIP_FAIL";

// UPDATE PAYSLIP
export const UPDATE_PAYSLIP_REQUEST = "UPDATE_PAYSLIP_REQUEST";
export const UPDATE_PAYSLIP_SUCCESS = "UPDATE_PAYSLIP_SUCCESS";
export const UPDATE_PAYSLIP_FAIL = "UPDATE_PAYSLIP_FAIL";

// UPDATE_PAYSLIP_STATUS
export const UPDATE_PAYSLIP_STATUS_REQUEST = "UPDATE_PAYSLIP_STATUS_REQUEST";
export const UPDATE_PAYSLIP_STATUS_SUCCESS = "UPDATE_PAYSLIP_STATUS_SUCCESS";
export const UPDATE_PAYSLIP_STATUS_FAIL = "UPDATE_PAYSLIP_STATUS_FAIL";
